module.exports = __webpack_public_path__ + "img/7-min.40813eb6.jpg";